<template>
  <nav id="nav-left-sidebar" class="nav-left-sidebar d-flex flex-column">
    <button id="nav-left-btn" class="nav-btn btn" type="button">
      <span><i class="icofont-navigation-menu"></i></span>
    </button>
    <div class="nav-left-header">
      <div class="dropdown mb-3">
        <a
          href="#"
          class="dropdown-ellipses dropdown-toggle mr-2"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div class="d-flex align-items-center">
            <div class="avatar col-4">
              <img v-if="user.logo" :src="user.logo" class="avatar-img rounded-circle" />
              <img v-if="!user.logo" src="@/assets/images/user_logo.jpg" class="avatar-img rounded-circle" />
            </div>
            <h5 class="text-wrap text-light text-uppercase col-8 p-0 text-center">{{ user.companyName }}</h5>
          </div>
        </a>
        <h5 class="text-wrap text-light text-uppercase mt-4 p-0 text-right">Balance: 0.00 $</h5>
        <div class="dropdown-menu dropdown-menu-right">
          <a v-if="user.role == 'operator'" :href="'/dashboard/user/setting/' + user.id" class="dropdown-item">
            Company Information
          </a>

          <a href="/dashboard/user/update/password" class="dropdown-item">Change Password</a>
          <a href="javascript:void(0)" @click="userLogout()" class="dropdown-item">Log Out</a>
        </div>
      </div>
    </div>
    <hr class="mb-2" />
    <ul class="nav flex-column h-100 nice-scroll">
      <li class="nav-item">
        <a class="nav-link" href="/dashboard">Dashboard</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="/dashboard/reviews">Reviews</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="/dashboard/quotes">Quote Request</a>
      </li>

      <li v-if="user.role == 'operator'" class="nav-item">
        <a class="nav-link" href="/dashboard/tour">Tours</a>
      </li>
      <li v-if="user.role == 'operator'" class="nav-item">
        <a class="nav-link" href="/dashboard/user/wallet">Wallet</a>
      </li>

      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/operators">Operators</a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/packages">Packages</a>
      </li>

      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/blog/post">Blog </a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/destination/post"> Destination </a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/landing-page/page">Landing Page</a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/things-to-do/page">Things to do</a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/places-to-visit/page">Places to visit</a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/tour-activity"> Tour Activity </a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/photos">Photo Management</a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/accommodation">Accommodation</a>
      </li>
      <li v-if="user.role == 'admin'" class="nav-item">
        <a class="nav-link" href="/dashboard/general-setting">General Setting</a>
      </li>
    </ul>

    <div class="sidebar-footer mt-2">
      <hr />
      <p class="text-center">Version {{ version }}</p>
    </div>
  </nav>
</template>

<script>
import Cookies from "js-cookie";
import pkg from "../../../package.json";
import { Constants } from "../../constants.js";
import { mapGetters } from "vuex";

export default {
  name: "Navbar",

  data() {
    return {
      version: pkg.version,
    };
  },

  computed: mapGetters(["user"]),

  methods: {
    userLogout() {
      Cookies.remove(Constants.LOGIN_USER);
      Cookies.remove(Constants.API_TOKEN);
      localStorage.clear();
      window.location.href = "/";
    },
  },
};
</script>
